import { Component, inject } from '@angular/core';
import { TourDetailInterface } from '../../../core/models';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SimpleCheckModalComponent } from '../../../common/modals/simple-check-modal.component';
import { TourDetailService } from '../../../services/resources/tour-detail.service';
import { TimestampToDatePipe } from '../../../core/timestamp-to-date.pipe';
import { isTransparent } from '../../../core/color.utils';

@Component({
  selector: 'app-tours-dashboard',
  imports: [
    CommonModule,
    RouterModule,
    SimpleCheckModalComponent,
    TimestampToDatePipe,
  ],
  template: `
    <div class="mx-auto max-w-7xl pt-6 px-4 sm:px-6 lg:px-8">
      <div class="px-4 sm:px-6 lg:px-8">
        <div class="sm:flex sm:items-center pt-6">
          <div class="sm:flex-auto">
            <h1 class="text-base font-semibold leading-6 text-gray-900">
              Tours
            </h1>
            <p class="mt-2 text-sm text-gray-700">
              A list of all the Tours for booking.
            </p>
          </div>
          <div class="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
            <button
              type="button"
              routerLink="/tours/new"
              class="justify-center disabled:opacity-25 rounded-md bg-columbus-blue-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-columbus-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-columbus-blue-600"
            >
              Create new Tour
            </button>
          </div>
        </div>
        <div class="mt-8 flow-root">
          <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div
              class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8"
              *ngIf="tours$ | async as tours"
            >
              <table class="min-w-full divide-y divide-gray-300">
                <thead>
                  <tr>
                    <th
                      scope="col"
                      class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0"
                    >
                      ID - Identifier
                    </th>
                    <th
                      scope="col"
                      class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0"
                    >
                      Tour Name
                    </th>
                    <th
                      scope="col"
                      class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Color Code
                    </th>
                    <th
                      scope="col"
                      class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Created
                    </th>
                    <th
                      scope="col"
                      class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Edited
                    </th>
                    <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-0">
                      <span class="sr-only">Edit</span>
                    </th>
                  </tr>
                </thead>
                <tbody class="divide-y divide-gray-200">
                  <tr *ngFor="let tour of tours">
                    <td
                      class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-light text-gray-600 sm:pl-0"
                    >
                      {{ tour.id }}
                    </td>
                    <td
                      class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0"
                    >
                      {{ tour.tourName }}
                    </td>
                    <td
                      class="whitespace-nowrap px-3 py-4 text-sm text-gray-500"
                    >
                      <div
                        class="w-full h-4 rounded border"
                        [ngClass]="{
                          checkerboard: isTransparent(tour.colorCode),
                        }"
                        [style.backgroundColor]="
                          isTransparent(tour.colorCode)
                            ? 'transparent'
                            : tour.colorCode
                        "
                      ></div>
                    </td>
                    <td
                      class="whitespace-nowrap px-3 py-4 text-sm text-gray-500"
                    >
                      {{
                        tour.createdDate | timestampToDate | date: 'dd.MM.YYYY'
                      }}
                    </td>
                    <td
                      class="whitespace-nowrap px-3 py-4 text-sm text-gray-500"
                    >
                      {{
                        tour.lastEditDate | timestampToDate | date: 'dd.MM.YYYY'
                      }}
                    </td>
                    <td
                      class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-0"
                    >
                      <div class="flex flex-row justify-around">
                        <div
                          routerLink="/tours/{{ tour.id }}"
                          class="text-columbus-blue-600 hover:text-columbus-blue-900 hover:cursor-pointer"
                        >
                          Edit<span class="sr-only">Edit</span>
                        </div>
                        <div
                          (click)="onDelete(tour)"
                          class="text-red-600 hover:text-red-900 hover:cursor-pointer"
                        >
                          Delete<span class="sr-only">Delete</span>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <!-- More people... -->
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="onDeleteToggle && selectedTour">
      <app-simple-check-modal
        [title]="'Delete Tour ' + selectedTour.tourName"
        [message]="'Do you want to delete the tour?'"
        [positiveButtonText]="'Yes'"
        [negativeButtonText]="'No'"
        (close)="onCloseDeleteModal($event)"
      ></app-simple-check-modal>
    </div>
  `,
  styles: `
    .checkerboard {
      background-image:
        linear-gradient(45deg, #6b7280 25%, transparent 25%),
        linear-gradient(-45deg, #6b7280 25%, transparent 25%),
        linear-gradient(45deg, transparent 75%, #6b7280 75%),
        linear-gradient(-45deg, transparent 75%, #6b7280 75%);
      background-size: 8px 8px;
      background-position:
        0 0,
        0 4px,
        4px -4px,
        -4px 0;
    }
  `,
})
export class ToursDashboardComponent {
  tourServices = inject(TourDetailService);
  tours$ = this.tourServices.getTours();
  selectedTour: TourDetailInterface | undefined = undefined;
  onDeleteToggle = false;

  toggleDeleteModal() {
    this.onDeleteToggle = !this.onDeleteToggle;
  }

  onDelete(tour: TourDetailInterface) {
    this.selectedTour = tour;
    this.toggleDeleteModal();
  }

  onCloseDeleteModal(value: boolean) {
    if (value && this.selectedTour) {
      this.tourServices.deleteTour(this.selectedTour.id);
    }

    this.toggleDeleteModal();
  }

  isTransparent(color: string | undefined): boolean {
    return isTransparent(color);
  }
}
